import { BoldTextButton } from "thrive-components";
import { getCommentPostTitle } from "../notificationTitles.service";


export interface ICommentPostTitle {
    content: {
        id: number;
        title: string;
        link: string;
        isArchived: boolean;
        existsInMultiplePlaces: boolean;
    };
    user: string;
    isPopOut?: boolean
}

const CommentPostTitle = ({content, user, isPopOut}: ICommentPostTitle ) => {
    const {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle} = getCommentPostTitle({content, user, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation}

            <BoldTextButton
                ariaLabel={contentLinkAriaLabel}
                link={contentLink}
                text={contentLinkTitle}
            />
        </span>
    );
};
export default CommentPostTitle;
